import Icon from '@/components/atoms/Icon';
import { isScreenShareDetectionFeatureFlagEnabled } from '@/stores/clip';

interface UploadEditorReadinessBannerProps {
  layoutsReady: boolean;
}

export default function UploadEditorReadinessBanner({ layoutsReady }: UploadEditorReadinessBannerProps) {
  if (layoutsReady) {
    return null;
  }

  const bannerText = isScreenShareDetectionFeatureFlagEnabled()
    ? 'Screenshare and speaker settings will be available after the video is processed.'
    : 'Speaker settings will be available after the video is processed.';

  return (
    <div className="flex w-full shrink-0 items-center gap-2 bg-orange-100 py-2.5 pl-8 pr-4 text-orange-600">
      <Icon name="IconLoader2" className="size-4 shrink-0 animate-spin" />
      <span className="text-xs font-medium leading-[18px]">{bannerText}</span>
    </div>
  );
}
